import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol, ESMLoaderSymbol, PromiseCacheSymbol, ImportMapSymbol } from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactory } from './esmLoaderFactory'
import { PromiseCache } from './promiseCache'
import { ImportMapFactory } from './importMapFactory'
import { PublicAppWillMountHandler } from './publicAppWillMountHandler'
import { LifeCycle } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(PromiseCacheSymbol).to(PromiseCache)
	bind(ImportMapSymbol).to(ImportMapFactory)
	bind(ESMLoaderSymbol).to(ESMLoaderFactory)
	bind(LifeCycle.AppWillMountHandler).to(PublicAppWillMountHandler)
}

// Export symbols and types for use by other features
export { ESMLoaderSymbol, ImportMapSymbol } from './symbols'
export type { ImportMap, ImportMappingEntries, IBridgeModuleLoaderFactory } from './types'
